import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Seo } from "../components/Seo";
import { site } from "../config/site";

const CONFIRMATIONS = {
  reservation:
    "Votre demande de réservation a bien été reçue. Nous vous confirmons votre table par téléphone ou email dans les plus brefs délais. Pour une réservation urgente, appelez-nous directement au 07 75 77 29 51.",
  devis: "Votre demande de devis a bien été reçue. Nous revenons vers vous avec une proposition personnalisée sous 48 heures ouvrées.",
  contact: "Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.",
};

export default function Merci() {
  const [params] = useSearchParams();
  const type = params.get("type");
  const message = CONFIRMATIONS[type] || "Votre demande a bien été envoyée. Merci de votre confiance.";

  return (
    <main id="contenu-principal" className="min-h-[60vh] flex items-center bg-cream">
      <Seo title="Merci | TN FOOD" description="Votre demande a bien été envoyée." path="/merci" noindex />
      <div className="container mx-auto px-4 max-w-2xl text-center py-24" data-testid="merci-page">
        <CheckCircle className="h-16 w-16 mx-auto text-olive" strokeWidth={1.5} aria-hidden="true" />
        <h1 className="font-display text-3xl md:text-4xl font-bold text-encre mt-6">Merci !</h1>
        <p className="mt-4 text-lg text-taupe leading-relaxed" data-testid="merci-message">{message}</p>
        <p className="mt-6 text-taupe">
          Une question ? Appelez-nous au{" "}
          <a href={site.phoneHref} data-testid="merci-phone" className="text-terracotta font-semibold hover:underline">{site.phone}</a>.
        </p>
        <Link to="/" data-testid="merci-home" className="mt-8 inline-block rounded-full bg-terracotta text-cream px-8 py-3 font-semibold transition-colors hover:bg-terracotta-dark">
          Retour à l'accueil
        </Link>
      </div>
    </main>
  );
}
